<template>
  <div id="SubDaysInPeriodReport">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>

    <div id="page-content-wrapper" class="admin-content-area" >
       <template v-if="cantAccessPage === true">
          <div class="page-name">
            <div class="page-title">Sub Days In Period</div>
            <div class="web-action-btn btn-groups text-right">
                <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                    <i class="fp-export"></i> Export
                </a>
            </div>
          </div>
          <div class="container-fluid">
            <div class="admin-page-content contact-list">
               <data-table-filter-config :moduleName="'SubDaysInPeriodReport'" ref="filterComponent" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                <div class="data-table bg-white overflow-hidden">
                    <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                    <section class="bg-white data-table">
                        <custom-pagination
                            :page-changed="onPageChange"
                            :per-page-changed="onPerPageChange" :moduleName="'SubDaysInPeriodReport'" :position="'top'">
                        </custom-pagination>

                        <vue-good-table
                            ref="subDayPeriodTable"
                            mode="remote"
                            title="Sub Days In Period"
                            @on-page-change="onPageChange"
                            @on-sort-change="onSortChange"
                            @on-column-filter="onColumnFilter"
                            @on-per-page-change="onPerPageChange"
                            :totalRows="totalRecords"
                            :columns="userColumns"
                            :rows="rows"
                            :isLoading=false
                            :paginationOptions="{
                                enabled: false,
                                position: 'both',
                                perPage: perPage,
                                dropdownAllowAll: false,
                                setCurrentPage:listCurrentPage,
                                perPageDropdown:dropDownPerPage,
                            }"
                            :search-options="{
                            enabled: false,
                            }"
                            :sort-options="{
                            enabled: true,
                            }">
                        </vue-good-table>
                        <custom-pagination
                            :page-changed="onPageChange"
                            :per-page-changed="onPerPageChange">
                        </custom-pagination>
                    </section>
                </div>

            </div>
          </div>
       </template>
       <template v-else-if="cantAccessPage === false">
          <div class="container-fluid">
              <div class="bg-white text-center">
                  <h1>
                      Oops!</h1>
                  <h2>
                      403 </h2>
                  <div class="error-details">
                      Sorry!, You don't have permission to access this page.
                  </div>
              </div>
          </div>
      </template>
      <template v-else>
          <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>

import Vue from "vue";
 import {commonMixins} from '../../mixins/commonMixins';
 import {dataTableMixins} from '../../mixins/dataTableMixins';

export default {
  name: "RentalActivityReport",
  mixins: [commonMixins,dataTableMixins],
  data: () => ({
      cantAccessPage:"",
      loading: false,
      pageTitle:'Sub Days In Period',
      permissions:[],
      rows: [],
      totalRecords: 0,
      userColumns:[],
      columns:[
        {
            label: "Rental Facility",
            field: "location",
            filterable: true,
            fpFieldType:"option",
            hidden:false,
            width: '90px',
            filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "#location", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.onColumnFilter, //custom filter function that
            trigger: "enter" //only trigger on enter not on keyup
            }
        },
        {
            label: "Contract Type",
            field: "contract_type",
            fpFieldType:"option",
            filterable: true,
            hidden:false,
            filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "Contract Type", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.onColumnFilter, //custom filter function that
            trigger: "enter" //only trigger on enter not on keyup
            }
        },

        {
            label: "Agreement",
            field: "agreement_number",
            filterable: true,
            fpFieldType:"text",
            hidden:false,
            filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "code", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.onColumnFilter, //custom filter function that
            trigger: "enter" //only trigger on enter not on keyup
            }
        },
        {
            label: "Unit Number",
            field: "unit_no",
            filterable: true,
            fpFieldType:"text",
            hidden:false,
            width: '90px',
            filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "#Unit", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.onColumnFilter, //custom filter function that
            trigger: "enter" //only trigger on enter not on keyup
            }
        },
        {
            label: "Effective Date",
            field: "pickup_datetime",
            filterable: true,
            fpFieldType:"custom_date",
            hidden:false,
            filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "MM/DD/YYYY", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.onColumnFilter, //custom filter function that
            trigger: "enter" //only trigger on enter not on keyup
            }
        },
        {
            label: "Term Date",
            field: "dropoff_datetime",
            filterable: true,
            fpFieldType:"custom_date",
            hidden:false,
            filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "MM/DD/YYYY", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.onColumnFilter, //custom filter function that
            trigger: "enter" //only trigger on enter not on keyup
            }
        },

        {
            label: "Days Utilized In Period",
            field: "days_utilized",
            fpFieldType:"text",
            filterable: false,
            hidden:false,
            filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "Days Utilized in period", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.onColumnFilter, //custom filter function that
            trigger: "enter" //only trigger on enter not on keyup
            },
            sortable:false
        },
        {
            label: "Customer Number",
            field: "customer_code",
            fpFieldType:"text",
            filterable: true,
            hidden:false,
            filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "#Cust", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.onColumnFilter, //custom filter function that
            trigger: "enter" //only trigger on enter not on keyup
            }
        },
        {
            label: "Agreement Customer",
            field: "customer_name",
            fpFieldType:"text",
            filterable: true,
            hidden:false,
            filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "#Cust", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.onColumnFilter, //custom filter function that
            trigger: "enter" //only trigger on enter not on keyup
            }
        },
        {
            label: "Intended Use",
            field: "intended_use",
            filterable: false,
            fpFieldType:"text",
            hidden:false,
            width: '90px',
            filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "Intended User", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.onColumnFilter, //custom filter function that
            trigger: "enter" //only trigger on enter not on keyup
            },
            sortable:false
        },
        {
            label: "Replaced Unit",
            field: "replaced_unit",
            fpFieldType:"text",
            filterable: true,
            hidden:false,
            filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "Replaced Unit", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.onColumnFilter, //custom filter function that
            trigger: "enter" //only trigger on enter not on keyup
            },
        },
        {
            label: "Replaced Reason",
            field: "replaced_reason",
            filterable: true,
            fpFieldType:"text",
            hidden:false,
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "state", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                filterFn: this.onColumnFilter, //custom filter function that
                trigger: "enter" //only trigger on enter not on keyup
            }

        },
        {
            label: "Replaced Agreement",
            field: "replaced_agreement",
            filterable: true,
            fpFieldType:"text",
            hidden:false,
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "Agreement", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                filterFn: this.onColumnFilter, //custom filter function that
                trigger: "enter" //only trigger on enter not on keyup
            }

        },
        {
            label: "Agmt Sts",
            field: "status",
            filterable: true,
            fpFieldType:"option",
            hidden:false,
            filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "status", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: ['Pending','Active','Expired','Billed','Rented','Standby','Void'], // dropdown
            filterFn: this.onColumnFilter, //custom filter function that
            trigger: "enter" //only trigger on enter not on keyup
            },
        },
        {
            label: "Equip Group",
            field: "group",
            fpFieldType:"text",
            filterable: true,
            hidden:false,
            filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "group", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.onColumnFilter, //custom filter function that
            trigger: "enter" //only trigger on enter not on keyup
            },
        },
        {
            label: "Equip Type",
            field: "asset_type",
            filterable: true,
            fpFieldType:"option",
            hidden:false,
            filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "#vehicle_type", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.onColumnFilter, //custom filter function that
            trigger: "enter" //only trigger on enter not on keyup
            }
        },
        {
            label: "Assigned Replace Unit Facility",
            field: "assigned_facility",
            filterable: true,
            fpFieldType:"option",
            hidden:false,
            filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "po", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.onColumnFilter, //custom filter function that
            trigger: "enter" //only trigger on enter not on keyup
            }
        },
        {
            label: "Substitute Comments",
            field: "sustitute_commend",
            filterable: false,
            fpFieldType:"text",
            hidden:false,
            filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "#comment", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.onColumnFilter, //custom filter function that
            trigger: "enter" //only trigger on enter not on keyup
            }
        },
        {
            label: "Work Order Number",
            field: "work_order_no",
            filterable: true,
            fpFieldType:"text",
            hidden:false,
            filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "Work Order Number", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.onColumnFilter, //custom filter function that
            trigger: "enter" //only trigger on enter not on keyup
            }
        },
        {
            label: "WO Status",
            field: "wo_status",
            filterable: true,
            fpFieldType:"option",
            hidden:false,
            filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "WO Status", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.onColumnFilter, //custom filter function that
            trigger: "enter" //only trigger on enter not on keyup
            }
        },
        {
            label: 'Period Start Date',
            field: 'start_date',
            filterable: false,
            fpFieldType:"text",
            hidden:true,
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "MM/DD/YYYY", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                trigger: "enter" //only trigger on enter not on keyup
            }
        },
        {
            label: 'Period End Date',
            field: 'end_date',
            filterable: false,
            fpFieldType:"text",
            hidden:true,
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "MM/DD/YYYY", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                trigger: "enter" //only trigger on enter not on keyup
            }
        },
      ],
      action:'list',
      batchProcess:0,
      batchNum:"",

  }),
  watch:{
    permissions: function(permission) {
        var self = this;
        permission.forEach(function (permissions) {
            if(permissions.name == 'substitute_unit_report') {
                self.cantAccessPage = true;
            }
        });
        if(self.cantAccessPage == ''){
            self.cantAccessPage = false;
        }
    },
  },
  mounted: function(){
    var self = this;
    self.getPermissions();
  },
  methods:{
    cancelAll: function (cancelAll) {
        this.$refs.subDayPeriodTable.unselectAllInternal();
    },
    // exportReports: function() {
    //     var self = this;
    //     this.action = "export";
    //     this.loadList();
    // },
    loadList: function(){


      var self = this;
      self.loading = true;
      var date = new Date();
      var offset = date.getTimezoneOffset();
      $.ajax({
        url: process.env.ROOT_API + "/substitute_unit-report/list",
        type: "POST",
        crossDomain: true,
        headers: this.ajxHeaders,
        dataType: "json",
        data: {
          page: self.serverParams.page,
          perPage: self.serverParams.perPage,
          filters: this.serverParams.columnFilters,
          sort: this.serverParams.sort,
          offset: offset,
          action: self.action

        },
        success: function(data) {
          self.loading = false;
          //console.log(data.content[0]["id"]);
          if (data.status == "success") {
            if ( self.action == "export" ||  self.action == "export_queue") {
                if ( data.code == "201" ) {
                    alert(data.message);
                } else {
                    if ( self.action == "export" ) {
                        self.excel = data.content.web;
                        var save = document.createElement("a");
                        save.href = self.excel;
                        save.download = data.content.web;
                        save.target = "_blank";

                        document.body.appendChild(save);
                        save.click();
                        document.body.removeChild(save);
                    } else {
                        self.batchProcess = 1;
                        self.batchNum = data.content;
                    }
                }
                self.action = "list";
                // self.loadList();

            } else {
               if (data.content.row != undefined) {
                self.rows = data.content.row;
              }

              self.totalRecords = data.content.totalRecords;
            }


          }
        },
        error: function(jqXHR, exception) {
          self.loading = false;
            self.generateStatusCodeMessage(jqXHR,true,'reservation-list-booking')
        }
      });

    }

  }

}
</script>



// WEBPACK FOOTER //
// src/components/reports/SubDayInPeriodReport.vue